import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

/**
 * DuelToast — notification voyante en bas/haut d'écran quand un événement
 * duel survient (nouveau défi reçu, duel terminé, à toi de jouer).
 *
 * Disparaît automatiquement après AUTO_DISMISS_MS, ou au clic.
 * Cliquer mène directement à la page Duels.
 */
const AUTO_DISMISS_MS = 6000;

export default function DuelToast({ event, onClose }) {
  const navigate = useNavigate();
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    if (!event) return undefined;
    if (hovering) return undefined;
    const id = setTimeout(onClose, AUTO_DISMISS_MS);
    return () => clearTimeout(id);
  }, [event, hovering, onClose]);

  if (!event) return null;

  const handleClick = () => {
    onClose();
    navigate('/duels');
  };

  // Classe selon type pour styles différenciés (couleur d'accent)
  const typeClass = `duel-toast-${event.type}`;

  return (
    <AnimatePresence>
      <motion.div
        key={event.type + event.count}
        className={`duel-toast ${typeClass}`}
        initial={{ y: -80, opacity: 0, scale: 0.9 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        exit={{ y: -80, opacity: 0, scale: 0.95 }}
        transition={{ type: 'spring', damping: 18, stiffness: 200 }}
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        role="alert"
        aria-live="assertive"
      >
        <button
          className="duel-toast-body"
          onClick={handleClick}
          aria-label={`${event.text} — Toucher pour voir`}
        >
          <span className="duel-toast-icon">{event.icon}</span>
          <span className="duel-toast-text">{event.text}</span>
          <span className="duel-toast-arrow" aria-hidden="true">→</span>
        </button>
        <button
          className="duel-toast-close"
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          aria-label="Fermer"
        >
          ×
        </button>
      </motion.div>
    </AnimatePresence>
  );
}
